export enum ApiErrorCode {
  EXPIRED_CERTIFICATE = 'error.ApiError.EXPIRED_CERTIFICATE',
  NOT_QUALIFIED_CERTIFICATE = 'error.ApiError.NOT_QUALIFIED_CERTIFICATE',
  CORRUPTED_DOCUMENT = 'error.ApiError.CORRUPTED_DOCUMENT',
  CORRUPTED_SIGNATURE = 'error.ApiError.CORRUPTED_SIGNATURE',
  CORRUPTED_SIGNED_DATA = 'error.ApiError.CORRUPTED_SIGNED_DATA',
  CORRUPTED_TST_DATA = 'error.ApiError.CORRUPTED_TST_DATA',
  CORRUPTED_TST_TOKEN = 'error.ApiError.CORRUPTED_TST_TOKEN',
  INVALID_FILE_EXTENSION = 'error.ApiError.INVALID_FILE_EXTENSION',
  INVALID_SIGNER_CERTIFICATE_PATH = 'error.ApiError.INVALID_SIGNER_CERTIFICATE_PATH',
  INVALID_TST_UNIT_CERTIFICATE_PATH = 'error.ApiError.INVALID_TST_UNIT_CERTIFICATE_PATH',
  MISSING_SIGNER_CERTIFICATE_REVOCATION_STATUS = 'error.ApiError.MISSING_SIGNER_CERTIFICATE_REVOCATION_STATUS',
  MISSING_TST_UNIT_CERTIFICATE_REVOCATION_STATUS = 'error.ApiError.MISSING_TST_UNIT_CERTIFICATE_REVOCATION_STATUS',
  NOT_SUPPORTED_FILE_TYPE = 'error.ApiError.NOT_SUPPORTED_FILE_TYPE',
  NOT_YET_VALID_SIGNER_CERTIFICATE = 'error.ApiError.NOT_YET_VALID_SIGNER_CERTIFICATE',
  NOT_YET_VALID_TST_UNIT_CERTIFICATE = 'error.ApiError.NOT_YET_VALID_TST_UNIT_CERTIFICATE',
  NO_MORE_VALID_SIGNER_CERTIFICATE = 'error.ApiError.NO_MORE_VALID_SIGNER_CERTIFICATE',
  NO_MORE_VALID_TST_UNIT_CERTIFICATE = 'error.ApiError.NO_MORE_VALID_TST_UNIT_CERTIFICATE',
  NO_SIGNATURE_FOUND = 'error.ApiError.NO_SIGNATURE_FOUND',
  ONE_ORIGINAL_FILE_SUPPORTED = 'error.ApiError.ONE_ORIGINAL_FILE_SUPPORTED',
  REQ_BAD_FORMAT = 'error.ApiError.REQ_BAD_FORMAT',
  REQ_INVALID_BASE64_DETACHED_SIGNATURE = 'error.ApiError.REQ_INVALID_BASE64_DETACHED_SIGNATURE',
  REQ_INVALID_BASE64_SIGNED_DOCUMENT = 'error.ApiError.REQ_INVALID_BASE64_SIGNED_DOCUMENT',
  REQ_INVALID_DETACHED_SIGNATURE_FORMAT = 'error.ApiError.REQ_INVALID_DETACHED_SIGNATURE_FORMAT',
  REQ_INVALID_REPORT_TYPE = 'error.ApiError.REQ_INVALID_REPORT_TYPE',
  REQ_INVALID_SIGNED_DOCUMENT_FORMAT = 'error.ApiError.REQ_INVALID_SIGNED_DOCUMENT_FORMAT',
  REQ_MISSING_CLIENT_ID = 'error.ApiError.REQ_MISSING_CLIENT_ID',
  REQ_MISSING_SIGNED_DOCUMENT = 'error.ApiError.REQ_MISSING_SIGNED_DOCUMENT',
  REVOCKED_CERTIFICATE = 'error.ApiError.REVOCKED_CERTIFICATE',
  REVOKED_SIGNER_CERTIFICATE = 'error.ApiError.REVOKED_SIGNER_CERTIFICATE',
  REVOKED_TST_UNIT_CERTIFICATE = 'error.ApiError.REVOKED_TST_UNIT_CERTIFICATE',
  SERVICE_UNAVAILABLE = 'error.ApiError.SERVICE_UNAVAILABLE',
  UNCERTAIN_SIGNER_CERTIFICATE_REVOCATION_STATUS = 'error.ApiError.UNCERTAIN_SIGNER_CERTIFICATE_REVOCATION_STATUS',
  UNKNOWN_DSS_ERROR = 'error.ApiError.UNKNOWN_DSS_ERROR',
  UNKNOWN_ERROR = 'error.ApiError.UNKNOWN_ERROR'
}
